<template>
  <div class="page configuration-detail">
    <div class="page__sidebar">
      <configuration-sidebar
        v-if="sideBarData"
        :side-bar-options="sideBarData"
      />
    </div>
    <div class="page__main">
      <b-container
        class="configuration-detail-container flex-grow-1"
        fluid
      >
        <b-row class="m-2 h-100">
          <router-view
            :key="$route.path"
            @updateSideBarData="updateSideBarData"
          />
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import ConfigurationSidebar from '@/modules/configurationModule/detail/ConfigurationSidebar'
import CentersAndServicesSideBarOptions from '@/modules/configurationModule/detail/centersAndServices/sideBarOptions'
import DemographySideBarOptions from '@/modules/configurationModule/detail/demography/sideBarOptions'
import PeopleSideBarOptions from '@/modules/configurationModule/detail/peopleManagement/sideBarOptions'
import CasesSideBarOptions from '@/modules/configurationModule/detail/cases/sideBarOptions'
import SamplesSideBarOptions from '@/modules/configurationModule/detail/samples/sideBarOptions'
import ElementsSideBarOptions from '@/modules/configurationModule/detail/elements/sideBarOptions'
import AssaysSideBarOptions from '@/modules/configurationModule/detail/assays/sideBarOptions'
import IncidentsSideBarOptions from '@/modules/configurationModule/detail/incidents/sideBarOptions'
import LaboratorySideBarOptions from '@/modules/configurationModule/detail/laboratory/sideBarOptions'
import TemplatesSideBarOptions from '@/modules/configurationModule/detail/templates/sideBarOptions'
import LocalCasesSideBarOptions from '@/modules/configurationModule/detail/local-cases/sideBarOptions'
import LocalSamplesSideBarOptions from '@/modules/configurationModule/detail/local-samples/sideBarOptions'
import LocalAssaysSideBarOptions from '@/modules/configurationModule/detail/local-assays/sideBarOptions'
import LocalNotificationsSideBarOptions from '@/modules/configurationModule/detail/notifications/sideBarOptions'
import GlobalNotificationsSideBarOptions from '@/modules/configurationModule/detail/notifications/sideBarOptionsGlobal'
import LocalIncidentsSideBarOptions from '@/modules/configurationModule/detail/localIncidents/sideBarOptions'
import ShipmentsSideBarOptions from '@/modules/configurationModule/detail/shipments/sideBarOptions'
import AccountingSideBarOptions from '@/modules/configurationModule/detail/accounting/sideBarOptions'
import LocalAccountingSideBarOptions from '@/modules/configurationModule/detail/local-accounting/sideBarOptions'
import AutomationSideBarOptions from '@/modules/configurationModule/detail/automation/sideBarOptions'
import PrintSideBarOptions from '@/modules/configurationModule/detail/print/sideBarOptions'
import VitrolinkSideBarOptions from '@/modules/configurationModule/detail/vitrolink/sideBarOptions'
import InstrumentationSideBarOptions from '@/modules/configurationModule/detail/instrumentation/sideBarOptions'
import LocalArchiveSideBarOptions from '@/modules/configurationModule/detail/local-archive/sideBarOptions'
import LaboratoryModuleSideBarOptions from '@/modules/configurationModule/detail/local-laboratory-module/sideBarOptions'
import { router } from '@/router'

export default {
    name: 'ConfigurationDetail',
    components: {
        ConfigurationSidebar
    },
    data() {
        return {
            sideBarData: null
        }
    },
    watch: {
        sideBarData() {
            // TODO: set location type to RawLocation from vue-router when migrates to TypeScript
            const location = { name: this.sideBarData.sidebar[0].routeName }

            // for grids
            const gridRoute = this.sideBarData.sidebar.find(option => option.routeName === router.currentRoute.name)
            if (gridRoute) {
                location.name = gridRoute.routeName
            }

            // for the configuration parameters
            if (router.currentRoute.name.startsWith('ConfigurationParameters')) {
                location.name = router.currentRoute.name

                if (router.currentRoute.params.id) {
                    // adds group id to params when any group is selected
                    location.params = { id: +router.currentRoute.params.id }
                } else {
                    // sets the default parameters group when no group was selected
                    location.params = { id: +this.sideBarData.sidebar[0].routeParams.id }
                }
            }

            router.push(location)
        }
    },
    created() {
        const routesMatched = router.currentRoute.matched.length - 1
        let routeName = null
        if (router.currentRoute.matched[routesMatched].parent.meta.name === 'ConfigurationIndex') {
            routeName = router.currentRoute.name
        } else {
            routeName = router.currentRoute.matched[routesMatched].parent.name
        }
        switch (routeName) {
        case 'ConfigurationCentersAndServices':
            this.sideBarData = CentersAndServicesSideBarOptions
            break
        case 'ConfigurationDemography':
            this.sideBarData = DemographySideBarOptions
            break
        case 'ConfigurationUsers':
            this.sideBarData = PeopleSideBarOptions
            break
        case 'ConfigurationCases':
            this.sideBarData = CasesSideBarOptions
            break
        case 'ConfigurationSamples':
            this.sideBarData = SamplesSideBarOptions
            break
        case 'ConfigurationElements':
            this.sideBarData = ElementsSideBarOptions
            break
        case 'ConfigurationAssays':
            this.sideBarData = AssaysSideBarOptions
            break
        case 'ConfigurationIncidents':
            this.sideBarData = IncidentsSideBarOptions
            break
        case 'ConfigurationLaboratory':
            this.sideBarData = LaboratorySideBarOptions
            break
        case 'ConfigurationTemplates':
            this.sideBarData = TemplatesSideBarOptions
            break
        case 'ConfigurationLocalCases':
            this.sideBarData = LocalCasesSideBarOptions
            break
        case 'ConfigurationLocalSamples':
            this.sideBarData = LocalSamplesSideBarOptions
            break
        case 'ConfigurationLocalAssays':
            this.sideBarData = LocalAssaysSideBarOptions
            break
        case 'ConfigurationLocalNotifications':
            this.sideBarData = LocalNotificationsSideBarOptions
            break
        case 'ConfigurationGlobalNotifications':
            this.sideBarData = GlobalNotificationsSideBarOptions
            break
        case 'ConfigurationLocalIncidents':
            this.sideBarData = LocalIncidentsSideBarOptions
            break
        case 'ConfigurationShipments':
            this.sideBarData = ShipmentsSideBarOptions
            break
        case 'ConfigurationAccounting':
            this.sideBarData = AccountingSideBarOptions
            break
        case 'ConfigurationLocalAccounting':
            this.sideBarData = LocalAccountingSideBarOptions
            break
        case 'ConfigurationAutomation':
            this.sideBarData = AutomationSideBarOptions
            break
        case 'ConfigurationPrint':
            this.sideBarData = PrintSideBarOptions
            break
        case 'ConfigurationVitrolink':
            this.sideBarData = VitrolinkSideBarOptions
            break
        case 'ConfigurationInstrumentation':
            this.sideBarData = InstrumentationSideBarOptions
            break
        case 'ConfigurationLocalArchive':
            this.sideBarData = LocalArchiveSideBarOptions
            break
        case 'ConfigurationLaboratoryModule':
            this.sideBarData = LaboratoryModuleSideBarOptions
            break
        }
    },
    methods: {
        updateSideBarData(sideBarData) {
            this.sideBarData = sideBarData
        }
    }
}

</script>

<style lang="scss">

.configuration-detail .configuration-pretitle {
    font-size: font-size(normal);
}

.configuration-detail .configuration-title {
    font-size: font-size(big);
    color: vt-color(dark-text);
}

.configuration-detail .configuration-detail-container {
    min-height: 0;
    margin-bottom: 50px;
}

.configuration-detail .grid-container {
    height: 100%;
}

.configuration-detail .switch-label {
    font-size: font-size(very-small);
    color: vt-color(dark-text);
}

.configuration-detail .switch {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
    cursor: pointer;
}

.configuration-detail .switch::after {
    content: "";
    position: absolute;
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}

.configuration-detail input[type="checkbox"]:checked + .switch::after {
    transform: translateX(20px);
}

.configuration-detail input[type="checkbox"]:checked + .switch {
    background-color: vt-color(primary);
}

.configuration-detail .offscreen {
    position: absolute;
    left: -9999px;
}

.configuration-detail .modal-content .card-header {
    background: transparent;
    width: 200px;
}

.configuration-detail .tab-scroll-content {
    height: calc(100% - 75px);
    overflow-y: auto;
}
.configuration-detail .tab-scroll-content.without-footer {
    height: calc(100% - 35px);
}

.configuration-detail .tab-pane {
    height: 100%;
}

.configuration-detail .tab-content,
.configuration-detail .association-table {
    min-height: 400px;
}

.configuration-detail .tabs.vt-tabs {
     height: 100%;
 }

.configuration-notifications-modal-form .nav-item:not(.secondary-tab-item) {
    font-size: font-size(very-small);
    border-radius: 0.25rem;
    margin-bottom: 5px;
}

.configuration-detail .nav.nav-pills {
    padding: 5px;
    padding-top: 0;
}

.configuration-detail .title {
    color: vt-color(primary);
    font-size: font-size(normal);
}

.configuration-detail .option {
    font-size: font-size(very-small);
    color: vt-color(dark-text);
}

.configuration-detail .modal-content .system-badge {
    background: vt-color(primary, .5);
    font-weight: normal;
    text-transform: uppercase;
}

.configuration-detail .association-table .fixed-column {
    width: 307px;
    position:sticky;
    left:0;
    padding-right: 20px;
    z-index: 1;
    transition: .2s;
}

.configuration-detail .association-table .fixed-column span {
    font-size: font-size(very-small);
}

.configuration-detail .association-table .check-column {
    width: 160px;
}

.configuration-detail .association-table .check-column span {
    font-size: font-size(small);
    width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.configuration-detail .association-table .bottom-line {
    border-bottom: 1px solid vt-color(dark-text, .8);
    padding: 10px 0;
    transition: .2s;
}

.configuration-detail .association-table .bottom-line:hover {
    background: vt-color(light-primary);
}

.configuration-detail .association-table span.assigned {
    color: vt-color(primary);
}

.configuration-detail .vt-side-panel {
    width: 450px !important;
}

.configuration-detail .scroll-area {
    height: calc(100% - 50px);
    overflow-y: auto;
}

.configuration-detail .footer-area {
    position: sticky;
    width:100%;
    left:0;
    bottom:0;
}

.configuration-detail .sidepanel-tabs .nav-link {
    font-size: font-size(small) !important;
}

.configuration-detail .header-row {
    position: sticky;
    top: 0;
    z-index: 2;
}

.configuration-detail .header-row div {
    background: #FFF;
}

.configuration-detail .text-zone {
    border: 1px solid #707070;
    border-radius: .2rem;
}

.configuration-detail .text-zone textarea.form-control {
    border: none;
    height: 120px;
}

.configuration-detail .text-zone input {
    border: none;
    padding: 10px;
    font-size: 1rem;
}

.configuration-detail .identifiers {
    border-bottom: 1px solid vt-color(general-border);
    background: vt-color(dark-text, .98);
}

.configuration-detail .id-zone .badge {
    background: vt-color(alt-primary);
    color: #FFF;
    cursor: pointer;
    transition: .2s;
    margin-right: 5px;
    font-size: font-size(small);
}

.configuration-detail .id-zone .badge:hover,
.configuration-detail .id-zone .badge.active {
    background: vt-color(primary);
}

.configuration-detail .empty-badge {
    font-style: italic;
    color: vt-color(dark-text);
    font-size: font-size(very-small);
}

.configuration-detail .destination-zone .multiselect__tags {
    height: 100px;
    overflow-y: auto;
}

.configuration-detail .destination-zone .custom-checkbox span {
    font-size: font-size(very-small);
}

@media (min-width: 1400px){
    .configuration-detail .container {
        max-width: 1600px;
    }
}

</style>
